define("shared/components/shared/ui/list-uploaded-items", ["exports", "@ember/component", "@glimmer/component", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _component2, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{this.className}}>
    {{#each @allUploadedFiles as |file|}}
      <div class="u--p__tb">
        <a href={{file.url}} rel="noopener noreferrer" target="_blank">
          {{file.filename}}
        </a>
  
        <Shared::Ui::Button
          @onClick={{action @removeFile file}}
          @variant="none"
          aria-hidden="true"
          class="o--alert__dismiss"
        >
          {{svg-jar "close" class="o--icon"}}
        </Shared::Ui::Button>
  
        <br />
      </div>
    {{/each}}
  </div>
  */
  {
    "id": "cMdtYaGW",
    "block": "[[[10,0],[15,0,[30,0,[\"className\"]]],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"    \"],[10,0],[14,0,\"u--p__tb\"],[12],[1,\"\\n      \"],[10,3],[15,6,[30,2,[\"url\"]]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n        \"],[1,[30,2,[\"filename\"]]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,2],[[24,\"aria-hidden\",\"true\"],[24,0,\"o--alert__dismiss\"]],[[\"@onClick\",\"@variant\"],[[28,[37,3],[[30,0],[30,3],[30,2]],null],\"none\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[2]],null],[13]],[\"@allUploadedFiles\",\"file\",\"@removeFile\"],false,[\"each\",\"-track-array\",\"shared/ui/button\",\"action\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/list-uploaded-items.hbs",
    "isStrictMode": false
  });
  class ListUploadedItemsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "className", `list-uploaded-items-${(0, _uuid.default)()}`);
    }
  }
  _exports.default = ListUploadedItemsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListUploadedItemsComponent);
});